
import { NgModule, ModuleWithProviders } from '@angular/core';

import {
  ErrorService,
  AuthenticationService,
  FcmMessagingService,
  NotificationService,
  UserService,
  EnvironmentService,
  // PushNotificationService
} from '.';

const API_SERVICES = [
  ErrorService,
  AuthenticationService,
  NotificationService,
  FcmMessagingService,
  UserService,
  EnvironmentService,
  // PushNotificationService
];

@NgModule({
  declarations: [
  ],
  imports: [
  ],
  exports: [
  ]
})
export class ServicesModule {
  static forRoot(): ModuleWithProviders {
    return <ModuleWithProviders>{
      ngModule: ServicesModule,
      providers: [
        ...API_SERVICES
      ],
    };
  }
}



// WEBPACK FOOTER //
// ./src/app/services/services.module.ts